import * as yup from "yup";
// eslint-disable-next-line import/extensions
import currency from "currency.js";

export function mergeValidations(...schemas) {
  const [first, ...rest] = schemas;

  const merged = rest.reduce(
    (mergedSchemas, schema) => mergedSchemas.concat(schema),
    first
  );

  return merged;
}

export const optionalString = yup
  .string()
  .typeError("Invalid format")
  .nullable();

export const requiredString = yup
  .string()
  .typeError("Required")
  .required("Required");

export const requiredDate = yup
  .date()
  .typeError("Required")
  .required("Required");

export const optionalNumber = yup
  .number()
  .integer("Must be a number")
  .typeError("Must be a number")
  .nullable()
  .transform((value, originalValue) =>
    (typeof originalValue === "string" || originalValue instanceof String) &&
    originalValue.trim() === ""
      ? null
      : value
  );

export const requiredNumber = yup
  .number()
  .typeError("Must be a number")
  .required("Required");

export const requiredAgree = yup
  .boolean()
  .test("agree", "You must agree to proceed", val => Boolean(val) === true);

export const requiredEIN = requiredString.matches(
  /^\d{2}-?\d{7}$/,
  "Invalid EIN"
);

export const requiredSSN = requiredString.matches(
  /^\d{3}-?\d{2}-?\d{4}$/,
  "Invalid SSN"
);

export const requiredCurrency = requiredString.test(
  "currency",
  "Invalid",
  function(value) {
    if (typeof value === "number") {
      return true;
    }

    const c = currency(value, { separator: "", precision: 2 });
    const rslt = Number(c.format());
    return typeof rslt === "number";
  }
);

export const optionalCurrency = yup
  .string()
  .nullable()
  .test("currency", "Invalid", function(value) {
    if (typeof value === "number") {
      return true;
    }

    const c = currency(value, { separator: "", precision: 2 });
    const rslt = Number(c.format());
    return typeof rslt === "number";
  });

export const requiredEmail = requiredString.email("Invalid Email");

export const requiredUrl = requiredString.url("Invalid URL");
export const optionalUrl = yup
  .string()
  .nullable()
  .url("Invalid URL");

export const requiredPhone = requiredString.matches(
  // eslint-disable-next-line no-useless-escape
  /(?:(?:(?:\+)?1[\-\s\.])?(?:\s?\()?(?:[2-9][0-8][0-9])(?:\))?(?:[\s|\-|\.])?)(?:(?:(?:[2-9][0-9|A-Z][0-9|A-Z])(?:[\s|\-|\.])?)(?:[0-9|A-Z][0-9|A-Z][0-9|A-Z][0-9|A-Z]))/,
  "Invalid Phone"
);

export const optionalPhone = yup
  .string()
  .nullable()
  .matches(
    // eslint-disable-next-line no-useless-escape
    /(^$)|(?:(?:(?:\+)?1[\-\s\.])?(?:\s?\()?(?:[2-9][0-8][0-9])(?:\))?(?:[\s|\-|\.])?)(?:(?:(?:[2-9][0-9|A-Z][0-9|A-Z])(?:[\s|\-|\.])?)(?:[0-9|A-Z][0-9|A-Z][0-9|A-Z][0-9|A-Z]))/,
    "Invalid Phone"
  );

const poBoxExpression = /(\bP(OST|OSTAL)?\.?\s*O?(FFICE)?\.?\s*BOX\s+#*(\w+)\b)|(^\s?BOX\s+#*(\w+)\b)/i;
export const notPostalBox = yup
  .string()
  .test("po box", "Can't be PO Box", function(val) {
    if (typeof val !== "string") return true;
    if (val.match(poBoxExpression)) return false;
    if (val.trim().startsWith("POB")) return false;
    return true;
  });
